import React from "react";
import CV from "../../assets/Kushtrim_Shabani_CV.pdf";
import { HiOutlineArrowTopRightOnSquare } from "react-icons/hi2";

const CTA = () => {
  return (
    <div className="cta">
      <a href="#contact" className="btn btn-primary">
        Say hello
      </a>
      <a
        href={CV}
        className="btn btn-outline"
        target="_blank"
        rel="noreferrer"
      >
        Resume
        <HiOutlineArrowTopRightOnSquare className="btn__icon" />
      </a>
    </div>
  );
};

export default CTA;
